import { useEffect, useState } from "react";

const useSpotifyTracksData = (spotifyToken, requestUrl, albumId) => {
  const [albumTracks, setAlbumTracks] = useState([]);

  async function getTracks() {
    const dataParameters = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${spotifyToken}`,
      },
    };

    const dataResults = await fetch(requestUrl, dataParameters)
      .then((response) => response.json())
      .then((data) => {
        const finalAlbumTracks = data.items.map((track) => ({
          id: track.id,
          name: track.name,
          mainArtist: track.artists[0].name,
          previewUrl: track.preview_url,
        }));
        setAlbumTracks(finalAlbumTracks);
      });

    console.log(dataResults);
  }

  useEffect(() => {
    if (albumId?.length > 0) {
      getTracks();
    }
  }, [albumId]);

  return { albumTracks, setAlbumTracks };
};

export default useSpotifyTracksData;
